import { giphyBlack } from '@giphy/colors'
import { useContext, useEffect, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import MessageContext from 'shared/contexts/message'
import UserContext from 'shared/contexts/user'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import SelectList from '../../select-list'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import API from '../../supercut/shared/utils/api'
import FieldTitle from './field-title'

const api = new API()

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
`

const UploadNew = styled.div`
    cursor: pointer;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureWatermarkField = ({ field }: Props) => {
    const { watermark, setIsWatermarkOpen, previousWatermarks, setPreviousWatermarks, setWatermark } =
        useContext(CreationCaptureInfoContext)
    const { user } = useContext(UserContext)
    const [isLoading, setIsLoading] = useState<Boolean>(false)
    const { sendMessage } = useContext(MessageContext)

    useEffect(() => {
        // Fetch all previous watermarks this user has uploaded.
        const fetchUserWatermarks = async () => {
            setIsLoading(true)
            try {
                const watermarks = await api.getWatermarks(user.username)
                setPreviousWatermarks(watermarks)
            } catch (error) {
                setPreviousWatermarks([])
                sendMessage(`Unable to load previously used watermarks. Please refresh and try again.`, 'error')
            }
            setIsLoading(false)
        }
        fetchUserWatermarks()
    }, [])

    const onChange = (val: string) => {
        if (watermark?.id === val) {
            setWatermark()
        } else {
            const selectedIndex = previousWatermarks.findIndex((wm) => wm.id === val)
            setWatermark(previousWatermarks[selectedIndex])
        }
    }

    return (
        <Container>
            <FieldTitle field={field} />
            {isLoading ? (
                <DotsLoader />
            ) : (
                <SelectList
                    {...{
                        onChange,
                        popUpColor: giphyBlack,
                        value: watermark?.id,
                        options: previousWatermarks.map((wm) => ({
                            value: wm.id,
                            label: wm.filename,
                            preview: <img src={wm.imageUrl} alt="" />,
                        })),
                    }}
                >
                    <UploadNew onClick={() => setIsWatermarkOpen(true)}>Upload New</UploadNew>
                    <UploadNew onClick={() => setIsWatermarkOpen(true)}>See All</UploadNew>
                </SelectList>
            )}
        </Container>
    )
}

export default CreationCaptureWatermarkField
